import React from 'react';

const Footer = () => (
  <footer className="footer">
    <p>&copy; {new Date().getFullYear()} Dom the Developer. All rights reserved.</p>
  </footer>
);

export default Footer;
